<template>
  <CRow>

    <CCol sm="12">
      <CCard>

        <CCardHeader>
          <CIcon name="cil-group" />
          <h5 class="d-inline ml-2">Couriers</h5>
          <div class="card-header-actions">
            <CButton color="primary" :to="{ name: 'Add New Courier'}">
              <CIcon name="cil-plus" class="align-bottom" /><strong>Add / Restore</strong> Courier
            </CButton>
          </div>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "Couriers",
  components: {
    BackendTable,
  },
};
</script>
